import { Injectable, Type } from '@angular/core';
import { WidgetComponent } from './widget/widget.component';
import { Log } from '@gspwidget/util';

/**
 * instance 指运行时，在某处运行的一个部件。
 * 此服务被动收集、输出实例id与实例引用信息，
 * 主动调用者为 widgetComponent 或 portletComponent
 */
@Injectable({
  providedIn: 'root'
})
export class InstanceService {
  /** 部件实例引用信息 */
  instances: {
    [insId: string]: {
      // portletComp: PortletComponent,
      widgetComp?: WidgetComponent
    }
  } = {}

  constructor () { }

  getInsByPInsId (insId: string) {
    return this.instances[insId]
  }
  addInsInfo (insId: string, widgetComp: WidgetComponent, type: 'widgetComp' | 'portletComp') {
    if (!insId) Log.Warn('ins id 为空')
    if (!this.instances[insId]) this.instances[insId] = {}
    this.instances[insId][type] = widgetComp
  }
}
